import { initializeApp } from 'firebase/app';
// import config from '../config';
import client from '../clients';

const app = initializeApp(client.config.firebaseConfig);

export { app };
